import { useQuery } from '@tanstack/react-query';

type VersionSettings = {
  maxRetainedVersions: number;
};

export function useVersionSettings() {
  const { data } = useQuery<VersionSettings>({
    queryKey: ['documents', 'version-settings'],
    staleTime: Infinity,
  });

  return { maxRetainedVersions: data?.maxRetainedVersions ?? 5 };
}
